import React from "react";
import { initializeDataHelper, getDataHelper } from "./dataHelper";

export { getDataHelper };

export async function createForm(
  formContainer,
  formApiKey,
  formId,
  formBranch,
  formChannel,
  formConfig,
  initialValues = {},
) {
  initializeDataHelper();

  let parsedFormId = Number(formId);
  console.log("Parsed formId in createForm:", parsedFormId);

  const args = [
    formContainer,
    formApiKey,
    formId,
    formBranch,
    formChannel,
    formConfig,
    initialValues,
  ];

  switch (true) {
    case parsedFormId === 1054:
      const { default: createNeobankForm } =
        await import("./createNeobankForm");
      createNeobankForm(...args);
      break;
    case parsedFormId === 727:
      const { default: createMemberOnboardingBorderbankForm } =
        await import("./createMemberOnboardingBorderbankForm");
      createMemberOnboardingBorderbankForm(...args);
      break;
    case parsedFormId === 666:
      const { default: createHomeLoanBorderbankForm } =
        await import("./createHomeLoanBorderbankForm");
      createHomeLoanBorderbankForm(...args);
      break;
    case parsedFormId === 511:
      const { default: createPersonalLoanForm } =
        await import("./createPersonalLoanForm");
      createPersonalLoanForm(...args);
      break;
    default:
      const { default: createDefaultForm } =
        await import("./createDefaultForm");
      createDefaultForm(...args);
      break;
  }
}
